import { withInstall } from '@haohan/clw-utils'
import Button from './HHButtonWidge.vue'
export const HHButton = withInstall(Button)
export default HHButton
